export default __webpack_public_path__ + "static/media/ic_shib_24.f3f7edb4.svg";